import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import { DateTime } from 'luxon';

import Content from './ContentBox';
import CalendarPicker from './CalendarPicker';
import ClickOutside from 'app/src/elements/ClickListener';
import { dateRange } from './dateHelpers';

import {
  MarketOption,
  MarketOptionsContainer,
  OptionText
} from './selectElements';

const LimitDatesSelect = ({ limitDates, setLimitDates }) => {
  const [showOptions, setShowOptions] = useState(false);

  const options = [
    {
      label: 'Show All Fees for Selected Assets',
      limitDates: false
    },
    {
       label: 'Only Show Fees for Selected Assets During the Period',
      limitDates: true
    },
  ];

  const selectedOption = options.find(option => (
    option.limitDates === limitDates
  ));

  const handleSelect = selected => {
    setLimitDates(selected.limitDates);
    setShowOptions(false);
  };

  return (
    <View style={{ flex: 1 }}>
      <Pressable onPress={() => setShowOptions(true)}>
        <Content.ValueBox highlight={true}>
          <Content.Value color={'white'}>
            {limitDates ? 'Only Show Fees for Selected Assets During the Period' : 'Show All Fees for Selected Assets'}
          </Content.Value>
        </Content.ValueBox>
      </Pressable>

      {showOptions && (
        <ClickOutside onClick={() => setShowOptions(false)}>
          <MarketOptionsContainer>
            {options.map(option => {
              const selected =
                option.limitDates === limitDates

              return (
                <MarketOption
                  key={option.label}
                  onPress={() => handleSelect(option)}
                  selected={selected}
                >
                  <OptionText selected={selected}>{option.label}</OptionText>
                </MarketOption>
              );
            })}

          </MarketOptionsContainer>
        </ClickOutside>
      )}
    </View>
  );
};

export default LimitDatesSelect;
